import { Alert, Button, CircularProgress, Snackbar, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { usePermissionEvents } from "../../hooks/core/usePermissionEvents";

const PermissionsChangedNotice = () => {
    const { t } = useTranslation("core.permissions_changed");
    const { permissionsChanged, refreshing, applyChanges, dismiss } = usePermissionEvents();

    return (
        <Snackbar
            open={permissionsChanged}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
            <Alert
                severity="info"
                variant="filled"
                sx={{ alignItems: "center" }}
                action={
                    <Stack direction="row" spacing={1}>
                        <Button color="inherit" size="small" onClick={dismiss} disabled={refreshing}>
                            {t("buttons.later")}
                        </Button>
                        <Button
                            color="inherit"
                            size="small"
                            variant="outlined"
                            onClick={applyChanges}
                            disabled={refreshing}
                            startIcon={refreshing ? <CircularProgress color="inherit" size={14} /> : undefined}
                        >
                            {t("buttons.refresh")}
                        </Button>
                    </Stack>
                }
            >
                {t("message")}
            </Alert>
        </Snackbar>
    );
};

export { PermissionsChangedNotice };
